module.exports = __webpack_public_path__ + "static/media/photoSample.b60ae753.png";